import { Alert } from 'assets/icons';
import cn from 'classnames';
import { FormikErrors } from 'formik';
import './styles.scss';
interface InputErrorProps {
	errors: FormikErrors<{ [field: string]: any }>;
	name: string;
	isError: boolean;
	additionalError?: string | boolean;
	warnings?: string;
	cyErrorRef?: string;
}
export const InputError = ({ errors, name, isError, additionalError, warnings, cyErrorRef }: InputErrorProps) => (
	<div
		className={cn('inputError', {
			'inputError--visible': isError || additionalError || warnings,
			'inputError--hidden': !isError && !additionalError && !warnings,
		})}
	>
		<Alert className={cn('shrink-0 w-4.5 h-4.5', isError ? 'fill-error-500 ' : 'fill-warning-600')} />
		{isError || additionalError ? (
			<span data-cy={cyErrorRef}>{errors[name] || additionalError}</span>
		) : (
			<span className={cn({ 'text-warning-600': warnings })}>{warnings}</span>
		)}
	</div>
);

export default InputError;
